import React from "react";
import { useTranslation } from "react-i18next";
import { FmBasicModal, FmButton, FmCheckBox, FmTextField } from "../..";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import { useIsMobile } from "../../../Hooks";

import useStyles from "./FmSaveItemModal.style";
import { useDispatch, useSelector } from "react-redux";
import { AgriSolutionState, GeneralState, SolutionState } from "../../../Redux";
import countriesAndRegions from "../../../Translations/Languages/he/countriesAndRegions";

interface FmSaveItemModalProps {
    img: any;
    isOpen: any;
    onClose: any;
    saveItemModalAction: any;
}

interface IFormInputs {
    itemName: string;
    area: any;
}

const FmSaveItemModal = ({ img, isOpen, onClose, saveItemModalAction }: FmSaveItemModalProps) => {
    const classes = useStyles();
    const isMobile = useIsMobile();
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const locationCountryCode = useSelector(AgriSolutionState.Selectors.selectLocationCountryCodeState) as string;

    const countryName = countriesAndRegions.countries[locationCountryCode];
    const isAgri = useSelector(GeneralState.Selectors.selectIsAgri);

    const {
        handleSubmit,
        control,
        register,
        setValue,
        getValues,
        watch,
        formState: { errors },
    } = useForm<IFormInputs>({
        mode: "onSubmit",
        defaultValues: {
            itemName: "",
            area: countryName || "",
        },
    });

    const handleOnSubmit: SubmitHandler<IFormInputs> = async (data) => {
        isAgri ? await dispatch(AgriSolutionState.Actions.setItemName(data.itemName)) : await dispatch(SolutionState.Actions.setItemName(data.itemName));

        saveItemModalAction();
        onClose();
    };

    return (
        <FmBasicModal img={img} onClose={onClose} isOpen={isOpen}>
            <form onSubmit={handleSubmit(handleOnSubmit)}>
                <div className={isMobile ? classes.mobile_rightSide : classes.rightSide}>
                    <div className={classes.mobile_box}>
                        <span className={isMobile ? classes.mobile_title : classes.title}>{t("saveItemPopup.title")}</span>
                        <div className={classes.inputs_container}>
                            <div className={classes.input_wrapper}>
                                <Controller
                                    name={"itemName"}
                                    control={control}
                                    rules={{
                                        required: {
                                            value: true,
                                            message: t("validationErrors.fieldIsRequired"),
                                        },
                                    }}
                                    render={({ field }) => {
                                        return (
                                            <FmTextField
                                                {...register("itemName")}
                                                {...field}
                                                label={t("saveItemPopup.label1")}
                                                variant='filled'
                                                error={errors.itemName}
                                                value={field.value}
                                                helperText={errors.itemName?.message || ""}
                                                fullWidth
                                            />
                                        );
                                    }}
                                />
                            </div>
                            {isAgri && (
                                <div className={classes.input_wrapper}>
                                    <Controller
                                        name={"area"}
                                        control={control}
                                        render={({ field }) => {
                                            return (
                                                <FmTextField
                                                    disabled
                                                    {...register("area")}
                                                    {...field}
                                                    label={t("saveItemPopup.label2")}
                                                    variant='filled'
                                                    error={errors.area}
                                                    value={field.value}
                                                    helperText={errors.area?.message || ""}
                                                    fullWidth
                                                />
                                            );
                                        }}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                    <div className={classes.buttons_container}>
                        <FmButton fullWidth={isMobile ? "fullWidth" : "regular"} type='submit'>
                            {t("saveItemPopup.save")}
                        </FmButton>
                    </div>
                </div>
            </form>
        </FmBasicModal>
    );
};

export default FmSaveItemModal;
